const initButtons = (root = document) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.button').forEach((button) => {
        // Déjà initialisé (SSR + re-init après AJAX Hub)
        if (button.querySelector(':scope > .button_circle')) {
            return;
        }

        button.innerHTML = '<span>' + button.innerHTML + '</span>';

        const domBubble = document.createElement('div');
        domBubble.classList.add('button_circle_bubble');

        const domCircle = document.createElement('div');
        domCircle.appendChild(domBubble);
        domCircle.classList.add('button_circle');

        button.appendChild(domCircle);

        const circle = button.querySelector(':scope > .button_circle');
        const bubble = button.querySelector('.button_circle_bubble');
        if (!circle || !bubble) return;

        button.addEventListener('mouseenter', (e) => {
            const buttonBounds = button.getBoundingClientRect();
            const posX = e.clientX - buttonBounds.left;
            const posY = e.clientY - buttonBounds.top;
            circle.style.transform = 'translate(' + posX + 'px,' + posY + 'px)';
            bubble.style.transform = 'scale(1)';
            bubble.style.opacity = '1';
        });

        button.addEventListener('mouseleave', () => {
            bubble.style.transform = 'scale(0)';
            bubble.style.opacity = '0';
        });
    });
};

export { initButtons };
